import React from "react";

import { ContentTypeBadge } from "./styles";
import contentTypes from "./data/content-types";

export default function ContentTypeBadgeComponent({
  contentTypeId,
  postIdea,
  title = "",
  variant = "light",
  size = "m",
  clickable = false,
  maxWidth,
  ...restProps
}) {
  //"other" content type doesn't have a badge
  if (contentTypeId === "other") {
    return null;
  }

  const contentType = contentTypes[contentTypeId];
  return (
    <ContentTypeBadge
      $bgColor={contentType.bgColor}
      $color={contentType.color}
      $variant={variant}
      $size={size}
      $clickable={clickable}
      $maxWidth={maxWidth}
      {...restProps}
    >
      {postIdea ? postIdea : title || contentType.title}
    </ContentTypeBadge>
  );
}
